export const CHANGE_SHARED_STATE = 'DOCUMENT_SHARING_CHANGE_SHARED_STATE';
